import { createFileRoute } from '@tanstack/react-router';
import {
  getHelpArticleListsContent,
  useGetHelpArticleListsContentQuery,
  useGetHelpArticleQuery,
} from '@/store/services/xcover/endpoints/help';

export const Route = createFileRoute('/{-$locale}/help')({
  component: Help,
  loader: ({ context, params }) =>
    context.store.dispatch(
      getHelpArticleListsContent.initiate({
        helpType: 'partners',
        slug: 'revolut',
        locale: params.locale || 'en',
        auth: false,
      }),
    ),
  pendingComponent: () => <div>Loading...</div>,
});

// NOTE: This page is being kept as an example, fetching help data, leftover from POC, feel free to remove, change, do what you like

function Help() {
  const { locale } = Route.useParams();
  const { data, error } = useGetHelpArticleListsContentQuery({
    helpType: 'partners',
    slug: 'revolut',
    locale: locale || 'en',
    auth: false,
  });

  const { data: helpArticleData, error: helpArticleError } =
    useGetHelpArticleQuery({
      slug: 'travel-claimdocs',
      locale: locale || 'en',
      auth: false,
    });
  return (
    <>
      <div>Hello "/-$locale/help/" page!</div>
      {data && <pre>data: {JSON.stringify(data, null, 2)}</pre>}
      {error && <pre>error: {JSON.stringify(error, null, 2)}</pre>}
      {helpArticleData && (
        <pre>helpArticleData: {JSON.stringify(helpArticleData, null, 2)}</pre>
      )}
      {helpArticleError && (
        <pre>helpArticleError: {JSON.stringify(helpArticleError, null, 2)}</pre>
      )}
    </>
  );
}
